import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { OnlineSessionClient } from "../../parentApi";

export default new OnlineSessionClient(app_uri, axiosClient());
